<script lang="ts">
	import { getContext } from 'svelte';
	import { debounce } from '../../../helper/Extensions';
	import DefaultTextInput from '../../input/DefaultTextInput.svelte';
	import {
		buildFilterValue,
		FilterCondition,
		type FilterOption,
		type SimpleListContext
	} from '../../../types/ListTypes';

	const { updateFilterActivityState } = getContext<SimpleListContext>('enzianListContext');

	let filterCondition: FilterCondition = FilterCondition.EQ;

	interface Props {
		id?: string;
		//The whole information with EQ
		filterOption: FilterOption;
	}

	let { id = undefined, filterOption = $bindable() }: Props = $props();

	let handleFilterChange = debounce((e: KeyboardEvent) => {
		//Get the value from the input field
		const stringValue = (e.target as HTMLInputElement).value;

		if (stringValue != null && stringValue.length > 0) {
			//Update the external value.
			filterOption.value = buildFilterValue(stringValue, filterCondition);
			updateFilterActivityState();
		} else {
			//Update the external value.
			filterOption.value = null;
			updateFilterActivityState();
		}
	});

	function parseString(inputString: string | null): string {
		try {
			//Read value back in.
			if (inputString != null && inputString != 'null') {
				const values = inputString.split('|');
				return values.length >= 2 ? values[0] || '' : '';
			} else {
				return '';
			}
		} catch (err) {
			return '';
		}
	}
</script>

<DefaultTextInput
	{id}
	propertyName=""
	value={parseString(filterOption.value)}
	onKeyup={handleFilterChange}
/>
